import { Link } from "react-router-dom"

import './help.css'

export default function Help() {

  console.log("Help Menu")

  return (
    <div className="help" >
      <h2>Help Menu</h2>
      <br />
      <p>You can group items by prefixing them with say f for fruits.</p>
      <p>An example is: f apples, f bananas, etc.</p>
      <p>Common items can be flagged as such by clicking the
        reload button on the items and the item's left border color
        will change color from green to grey.
        These items can then be reloaded by clicking the reload
        button in the top Navbar menu.
      </p>
      <br />
      <p>Contact info RepairDude7@gmail.com</p>
      <br />
      <Link className="btnYes" to="/">Home</Link>

    </div>
  )
}